/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListTopics
 */
export interface ListTopics {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListTopics
     */
    topics: Array<string>;
}

export function ListTopicsFromJSON(json: any): ListTopics {
    return ListTopicsFromJSONTyped(json, false);
}

export function ListTopicsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTopics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'topics': json['topics'],
    };
}

export function ListTopicsToJSON(value?: ListTopics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'topics': value.topics,
    };
}


